import { Routes } from '@angular/router';
import { InicioComponent } from './web/inicio/inicio.component';
// import { BookingWidgetComponent } from './components/karve/booking-widget/booking-widget.component';
import { authGuard } from './auth.guard';
// import { FurgonetasComponent } from './web/furgonetas/furgonetas.component';
// import { PrivacidadComponent } from './web/privacidad/privacidad.component';
import { Error404Component } from './web/error404/error404.component';

interface routeStructureInterface {
  home: string[];
  // vans: string[];
  // rent: string[];
  rooms: string[];
  roomDetail: string[];
  privacy: string[];
  terms: string[];
  legal: string[];
  team: string[];
  contact: string[];
  order: string[];
  booking: string[];
  news: string[];
  accident: string[];
  cancellationPolicy: string[];
}

export const routeStructure: routeStructureInterface = {
  home: ['inicio', 'home'],
  // vans: ['furgonetas', 'vans'],
  // rent: ['alquiler', 'rent'],
  rooms: ['rooms', 'habitaciones', 'productos'],
  roomDetail: ['room-detail', 'habitacion-detalle'],
  privacy: ['privacidad', 'privacy'],
  terms: ['terminos', 'terms'],
  legal: ['aviso-legal', 'legal-warning'],
  team: ['nuestro-equipo', 'our-team'],
  accident: ['caso-accidente', 'accident-case'],
  contact: ['contacto', 'contact'],
  order: ['order', 'pedido'],
  news: ['noticias', 'news'],
  booking: ['booking', 'reserva'],
  cancellationPolicy: ['cancellation-policy', 'politica-cancelacion'],
};

export const routes: Routes = [
  { path: '', component: InicioComponent, pathMatch: 'full' },
  ...routeStructure.home.map(path => ({
    path,
    component: InicioComponent,
  })),
  {
    path: 'login',
    loadChildren: () => import('@ls-commons/login').then(r => r.loginRoutes),
    data: {
      title: $localize`:@@login.title:Iniciar Sesión`,
      loginGoogle: false,
      linkBack: '/login',
    },
  },
  {
    path: 'dashboard',
    // title: $localize`:@@title.dashboard:Panel`,
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then(r => r.dashboardRoutes),
  },

  // ...routeStructure.vans.map((path) => ({
  //   path,
  //   component: FurgonetasComponent,
  // })),
  // ...routeStructure.rent.map((path) => ({
  //   path,
  //   component: BookingWidgetComponent,
  // })),
  // ...routeStructure.privacy.map((path) => ({
  //   path,
  //   component: PrivacidadComponent,
  // })),
  // ...routeStructure.terms.map((path) => ({
  //   path,
  //   loadComponent: () =>
  //     import('./web/terminos/terminos.component').then(
  //       (r) => r.TerminosComponent
  //     ),
  // })),
  ...routeStructure.legal.map(path => ({
    path,
    loadComponent: () =>
      import('./web/aviso-legal/aviso-legal.component').then(
        r => r.AvisoLegalComponent
      ),
  })),

  ...routeStructure.contact.map(path => ({
    path,
    loadComponent: () =>
      import('./web/contacto/contacto.component').then(
        r => r.ContactoComponent
      ),
  })),
  ...routeStructure.order.map(path => ({
    path,
    loadComponent: () =>
      import('./web/order/order/order.component').then(r => r.OrderComponent),
  })),
  {
    path: 'cookies',
    loadComponent: () =>
      import('./web/cookies/cookies.component').then(r => r.CookiesComponent),
  },
  // --------------------------------------------------------------------------
  // admin backoffice
  // {
  //   path: 'admin',
  //   loadChildren: () => import('@ls-commons/login').then((r) => r.loginRoutes),
  //   data: {
  //     title: 'Iniciar Sesión',
  //     loginGoogle: true,
  //   },
  // },
  // {
  //   path: 'dashboard',
  //   canActivate: [authGuard],
  //   loadComponent: () =>
  //     import('./admin/dashboard/dashboard.component').then(
  //       (r) => r.DashboardComponent
  //     ),
  // },
  // ---------
  { path: '**', component: Error404Component },
];
